import { render, staticRenderFns } from "./leaseMagtDetail.vue?vue&type=template&id=5fa990e9&scoped=true"
import script from "./leaseMagtDetail.vue?vue&type=script&lang=js"
export * from "./leaseMagtDetail.vue?vue&type=script&lang=js"
import style0 from "./leaseMagtDetail.vue?vue&type=style&index=0&id=5fa990e9&prod&lang=scss&scoped=true"
import style1 from "./leaseMagtDetail.vue?vue&type=style&index=1&id=5fa990e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa990e9",
  null
  
)

export default component.exports